import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { settings } from "@tumbodash/browserPackages";

function CreateParty() {
	const navigate = useNavigate();

	useEffect(() => {
		fetch(settings.serverUrl + "createParty")
			.then((response) => {
				if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
				return response.json() as Promise<{ partyId: string }>;
			})
			.then((data) => navigate(`/p/${data.partyId}`))
			.catch((error) => console.error("Error:", error));
	}, []);

	return <>Creating Party...</>;
}

export default CreateParty;
